export default __webpack_public_path__ + "static/media/BT.454b86e4.png";